<template>
    <div class="container-fluid">
        <div class="row justify-content-center">
            <div class="col-12">
                <div class="header mt-md-5">
                    <div class="header-body">
                        <div class="row align-items-center">
                            <div class="col">
                                <h6 class="header-pretitle">{{$t('manage')}}</h6>
                                <h1 class="header-title">{{$t('ICD-10')}}</h1>
                            </div>
                            <div class="col-auto">
                                <button
                                    @click="openModal({id:'icdEditModal', model:{parentId, language}})"
                                    class="btn btn-primary"
                                >{{$t('Add')}}</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <div class="card" data-toggle="lists">
                            <div class="card-header">
                                <div class="row align-items-center">
                                    <div class="col">
                                        <!-- Search -->
                                        <div class="row align-items-center">
                                            <div class="col-auto pr-0">
                                                <span class="fe fe-x text-muted" v-if="query" @click="query=null"></span>
                                                <span class="fe fe-search text-muted" v-else></span>
                                            </div>
                                            <div class="col">
                                                <input
                                                    type="search"
                                                    v-model="query"
                                                    class="form-control form-control-flush search no-glow"
                                                    :placeholder="$t('Search')"
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-auto">
                                        <b-button-group>
                                            <button
                                                class="btn btn-white"
                                                @click="specialtyQuery=[]"
                                                v-if="specialtyQuery.length>0"
                                            >
                                                <span class="fe fe-x"></span>
                                            </button>
                                            <b-dropdown variant="white" right :text="$t('Specialty')">
                                                <div
                                                    v-for="(specialty, index ) in specialties"
                                                    :key="index"
                                                    class="dropdown-item pl-3"
                                                >
                                                    <b-form-checkbox
                                                        v-model="specialtyQuery"
                                                        :value="specialty._id"
                                                    >{{specialty.label }}</b-form-checkbox>
                                                </div>
                                            </b-dropdown>
                                        </b-button-group>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body p-0 pl-4 pr-4" v-if="breadcrumbs.length>0">
                                <b-breadcrumb :items="breadcrumbs"></b-breadcrumb>
                            </div>

                            <simple-table
                                :data="icd"
                                :loading="icdLoading"
                                :edit="edit"
                                :rowButtons="rowButtons"
                                :deleteItem="deleteItem"
                                :columns="columns"
                                :sort="sort"
                                :hideDeleteButton="true"
                            ></simple-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <i-c-d-edit-modal id="icdEditModal" :data="model"></i-c-d-edit-modal>
        <!-- <cdb-list id="cdbListModal" :data="model"></cdb-list> -->
    </div>
</template>

<script>
import SimpleTable from '@/components/SimpleTable.vue'
import ICDEditModal from '@/components/ICD10/ICDEditModal.vue';
import { modalMixins } from '@/mixins/modal.js'
import { icdMixins } from '@/components/ICD10/icd-mixins.js'
import { mapActions, mapGetters, mapState } from 'vuex';


export default {
    props: ['parentId'],
    mixins: [modalMixins, icdMixins],
    components: {
        SimpleTable,
        ICDEditModal
    },
    data() {
        return {
            query: null,
            language: 'english',
            specialtyQuery: [],
            model: {},
            rowButtons: [
                // {
                //     label: 'Complaints',
                //     // action: 'openCdbModal',
                //     link: (item) => {
                //         return {
                //             name: 'company.cdb',
                //             params: { icd: item.code }
                //         }
                //     },
                // }
            ],
            columns: [
                {
                    label: 'Code',
                    name: 'code',
                    width: '5%',
                    subtitle(item) {
                        return item.shortcode;
                    }
                },
                {
                    label: 'Name',
                    name: 'label',
                    link: (item) => {
                        return {
                            name: 'company.icd',
                            params: { parentId: item._id }
                        }
                    },
                    field: (item) => {
                        if (item.label.length > 50) {
                            return item.label.substring(0, 50) + '...';
                        } else {
                            return item.label
                        }
                    },
                    subtitle: (item) => {
                        if (!item.description) return;
                        if (item.description.length > 50) {
                            return item.description.substring(0, 50) + '...';
                        } else {
                            return item.description;
                        }
                    },
                },


            ],
            sort: '',
            breadcrumbs: [],
        }
    },

    created() {
        this.queryItems();


    },
    computed: {
        icdList() {
            return this.findIcdInStore(this.params).data;
        },

    },
    methods: {
        ...mapActions('icd', ['find', 'create', 'patch', 'remove', 'get']),


        getParents(parentId) {
            if (!parentId) return;
            this.get(parentId).then(item => {
                this.breadcrumbs.unshift({
                    text: item.label,
                    to: {
                        name: 'company.icd',
                        params: {
                            parentId: item._id
                        }
                    },
                });

                if (item.parentId) {
                    this.getParents(item.parentId);
                } else {
                    this.breadcrumbs.unshift({
                        text: 'Home',
                        to: {
                            name: 'company.icd',
                        }

                    });
                }
            });
        },

        save() {
            let promise, successMessage;
            if (this.model._id) {
                promise = this.patch([this.model._id, this.model]);
                successMessage = 'ICD has been saved';
            } else {
                promise = this.create(this.model);
                successMessage = 'ICD has been created';
            }

            promise.then(result => {

                this.$root.$emit('bv::hide::modal', this.id);
                this.$toasted.global.success({
                    message: successMessage
                });

            });

        },
        edit(item) {
            this.openModal({ id: 'icdEditModal', model: item });
        },
        deleteItem(item) {
            this.remove(item._id).then(data => {
                this.$toasted.global.success({
                    message: this.$t('Item has been deleted')
                });
            })
        },
        openCdbModal(item) {
            this.openModal({ id: 'cdbListModal', model: item });
        }


    }
}
</script>
